import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import userSlice from '../features/user/userSlice'
import authSlice from '../features/auth/authSlice'   // ✅ new import

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  user: userSlice,
  auth: authSlice   // ✅ add here
}

export default configureStore({
  reducer: combinedReducer
})
